import { render } from "./PhoneNumberFromLeads.vue?vue&type=template&id=5825264f&scoped=true"
import script from "./PhoneNumberFromLeads.vue?vue&type=script&lang=js"
export * from "./PhoneNumberFromLeads.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./PhoneNumberFromLeads.vue?vue&type=style&index=1&id=5825264f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5825264f"]])

export default __exports__